import { Injectable } from '@angular/core';
import { ILightWeightArea, ILightWeightObject } from '@fi-shared/models';
import { IFiCheckboxItem } from '@fi-shared/fi-checkbox2/fi-checkbox2';

@Injectable()
export class FiCheckbox2AdapterService {
    constructor() {}

    mapLightWeightObjects(items: ILightWeightObject[], getClassFn?: (item: ILightWeightObject) => string) {
        return items.map((item) => {
            return <IFiCheckboxItem>{
                id: item.Id,
                name: item.Name,
                _class: getClassFn ? getClassFn(item) : '',
            };
        });
    }

    mapLightWeightAreas(areas: ILightWeightArea[], getClassFn?: (item: ILightWeightArea) => string) {
        return areas.map((area) => {
            let childItems: IFiCheckboxItem[];
            if (area.ChildItems && area.ChildItems.length) {
                childItems = this.mapLightWeightAreas(area.ChildItems, getClassFn);
            }
            /*
            // todo for test

            if (area.Id === 2222) {
                childItems = [{ id: 500, name : 'ww1' }, { id: 501, name : 'ww2' }, { id: 502, name : 'ww3' }]
            }
            if (area.Id === 2226) {
                childItems = [{ id: 504, name : 'ww4' }, { id: 505, name : 'ww6' }]
            }
*/
            return <IFiCheckboxItem>{
                id: area.Id,
                name: area.Name,
                _class: getClassFn ? getClassFn(area) : '',
                childItems: childItems,
            };
        });
    }
}
